/**
 * Per-order facility fee for settlement / payment listings rows.
 * API uses `facilityFee` from `orders.facility_fee`; `fees.facility` covers alternate shapes.
 */
export function getFacilityFee(row) {
  const raw = row?.facilityFee ?? row?.fees?.facility ?? 0;
  const n = Number(raw);
  return Number.isFinite(n) ? n : 0;
}
